import getSymbolFromCurrency from 'currency-symbol-map';

import { OPEN_EU_DUTY_MODAL } from '../../constants/eventNames';
import {
  euDutyCountry,
  euDutyCountryCode,
  euDutyCurrency,
  euDutyCurrencySymbol,
  euDutyThresholdAmount,
  isEuDutyCurrencyIssue,
} from '../../lib/reactives';

const showEuDutyModal = (
  selectedAddress,
  cartCurrency,
  isEuDutyRestrictionEnabled,
  deliveryCountriesConfig,
  cartSubtotal,
) => {
  if (!isEuDutyRestrictionEnabled) {
    return false;
  }

  // Get the country currencies sorted by EUR for the selected address
  let selectedCountryConfig = deliveryCountriesConfig.find(
    (config) => config.countryCode === selectedAddress.country,
  );

  let selectedCountryCurrencies = [...selectedCountryConfig.currencies].sort(
    (a, b) => {
      if (a.code === 'EUR') return -1;
      if (b.code === 'EUR') return 1;
      return a.code.localeCompare(b.code);
    },
  );

  const selectedCountryCurrencyConfig = selectedCountryCurrencies.find(
    (currency) => currency.code === cartCurrency,
  );

  const isOrderable = selectedCountryCurrencyConfig
    ? (selectedCountryCurrencyConfig.orderable ?? true)
    : false;

  if (!isOrderable) {
    let recommendedCurrency = '';
    const orderableCurrencies = selectedCountryCurrencies.filter(
      (currency) => currency.orderable ?? true,
    );
    // pick first orderable currency
    if (orderableCurrencies.length > 0) {
      recommendedCurrency = orderableCurrencies[0].code;
      // pick EUR if orderable for the selected country as it's the main currency for EU countries
    } else if (
      selectedCountryCurrencies[0].code === 'EUR' &&
      (selectedCountryCurrencies[0].orderable ?? true)
    ) {
      recommendedCurrency = 'EUR';
      // fallback and pick the first currency in the list if no orderable currency or EUR is available for the selected country
    } else {
      recommendedCurrency =
        selectedCountryCurrencies[1].code ?? selectedCountryCurrencies[0].code;
    }

    // set the variables needed for the modal
    isEuDutyCurrencyIssue(true);
    euDutyCountry(selectedCountryConfig.countryName);
    euDutyCountryCode(selectedAddress.country);
    euDutyCurrency(recommendedCurrency);
    euDutyCurrencySymbol(getSymbolFromCurrency(recommendedCurrency));

    window.dispatchEvent(new Event(OPEN_EU_DUTY_MODAL));

    return true;
  }

  const minimumOrderValue =
    selectedCountryCurrencyConfig?.minimumOrderValue ?? '0';

  const isThresholdReached = cartSubtotal >= minimumOrderValue;

  if (!isThresholdReached) {
    // set the variables needed for the modal
    isEuDutyCurrencyIssue(false);
    euDutyCurrencySymbol(getSymbolFromCurrency(cartCurrency));
    euDutyThresholdAmount(String(minimumOrderValue));

    window.dispatchEvent(new Event(OPEN_EU_DUTY_MODAL));

    return true;
  }

  return false;
};

export default showEuDutyModal;
